import React from 'react'
import { Loader2, AlertTriangle } from 'lucide-react'

interface ProcessingToastProps {
  message?: string
}

export function ProcessingToast({ message = 'Processing Results' }: ProcessingToastProps) {
  return (
    <div className="fixed bottom-4 right-4 z-[100] max-w-sm p-4 bg-card rounded-lg border-2 border-primary/20 shadow-lg">
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <Loader2 className="h-6 w-6 text-primary animate-spin" />
          <div>
            <h3 className="font-medium">{message}</h3>
            <p className="text-sm text-muted-foreground">
              Processing will take 1-2 minutes
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm text-yellow-600 dark:text-yellow-400">
          <AlertTriangle className="h-4 w-4 flex-shrink-0" />
          <p>Do not close or navigate away from Syllepsis.io</p>
        </div>
      </div>
    </div>
  )
}